import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom"
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Autocomplete,
    TextField,
    Box,
    IconButton,
    FormControl,
    Stack,
    Grid,
    Typography,
    TablePagination,
} from "@mui/material";
import { filterOptions } from "../../../global/constants/globalContants.ts";
import DeleteIcon from "@mui/icons-material/Delete";
import { ApideleteAirTasker, ApiGetAirTaskerShopperList, ApiGetShopperList, ApiReportTempToken, ApiupdateAirTaskerStatus } from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
const AirTaskerList: React.FC = () => {
    const navigate = useNavigate();
    // const addOrUpdateairtasker = (airtasker: any) {
    //     if (airtasker.userId) {
    //         navigate('')
    //     }
    // }
    const [shoppersList, setShoppersList] = useState<any>([])
    const [selectedFilter, setSelectedFilter] = useState<any>(null)
    const [datalength, setdatalength] = useState<any>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    
    const handleGetApiCall = async (status?: string) => {
        try {
            const filterStatus = status || selectedFilter?.value || "active"
            const data = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}&isAirTasker=true&status=${filterStatus}`
            const res = await ApiGetAirTaskerShopperList(data)
            setdatalength(res.count)
            setShoppersList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }

    const handleFilterChange = async (event: any, newValue: any) => {
        setSelectedFilter(newValue)
        setPage(0)
        if (newValue) {
            await handleGetApiCall(newValue.value)
        }
    }
    const deleteAirTasker = async (user: any) => {
        const data = {
            userId: user.userId,
        };
        try {
            const response: any = await ApideleteAirTasker(data);
            toast.success("AirTasker deleted successfully!");
            handleGetApiCall();
        } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Failed to delete AirTasker");
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            const defaultFilter = filterOptions[0]
            setSelectedFilter(defaultFilter)
            await handleGetApiCall(defaultFilter.value)
        }
        fetchData()
        return () => { }
    }, [rowsPerPage, page])

    const handleMoveShopper = async (userId: number) => {
        try {
            const data = {
                userId: userId,
                isAirTasker: false
            }
            const response = await ApiupdateAirTaskerStatus(data);
            handleGetApiCall();
            toast.success("Air Tasker Move Successfully.")
        } catch (error) {
            console.error("Error moving to Shopper", error);
            toast.error("Error moving to Shopper");
        }
    }


    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const OpenEditReport = async (item: any) => {
        try {
            const data = {
                reportHeaderId: item.reportHeaderId,
                allocationId: item.allocationId,
                clientGroupName: item?.allocationClientGroup
            }
            const res = await ApiReportTempToken(data)
            if (res.success) {
                sessionStorage.setItem('fromOriginalSite', 'true');
                window.open(`${process.env.REACT_APP_SHOPPER_SITE}?x-z-a=${res?.data?.token}`, '_blank');
            }
            else {
                toast.error(res?.message)
            }
        } catch (error: any) {
            toast.error(error?.message)
        }
    }
    // const currentShoppers = shoppersList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    const currentShoppers = shoppersList
    return (
        <Box className="w-100 p-2">
            <Box className='bg-light border-10 p-2'>
                <Grid container className=" mb-4 mt-3 align-items-center" gap={3}>
                    <Grid size={{ xs: 12, md: "auto" }} order={{ xs: 2, md: 1 }}>
                        <Stack direction="row" spacing={2} >
                            <Box style={{ width: "100%" }}>
                                <Box sx={{ mb: 3, display: "flex", gap: 2, alignItems: "center", width: { xs: "100%", md: "fit-content" } }}>
                                    <Autocomplete
                                        options={filterOptions}
                                        value={selectedFilter}
                                        getOptionLabel={(option) => option.label}
                                        onChange={handleFilterChange}
                                        renderInput={(params) => <TextField {...params} label="Filter by Status" />}
                                        sx={{ minWidth: { xs: "100%", md: 200 } }}
                                    />
                                </Box>
                            </Box>
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, md: "grow" }} order={{ xs: 1, md: 2 }}>
                        <Typography className="text-center fs-42">Air Tasker List</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: "auto" }} order={{ xs: 3, md: 3 }}>
                        <Link 
                            to={`/admin/shopper/add`}
                            // variant="contained"
                            // onClick={() => { navigate('/admin/shopper/add') }}
                            className="table-row-background py-2 link-btn"
                        >
                            Add New AirTasker
                        </Link>
                    </Grid>
                </Grid>
                <Box className='w-100' overflow={'auto'}>
                    <Table>
                        <TableHead>
                            <TableRow className="table-row-background">
                                {[
                                    "First Name",
                                    "Last Name",
                                    "User Name",
                                    "Email ID",
                                    "Last Report",
                                    "",
                                    "",
                                    "",
                                ].map((item) => (
                                    <TableCell style={{ color: "#fff" }}>{item}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {currentShoppers?.map((user: any) => (
                                <TableRow key={'user.userId'}>
                                    <TableCell>{user.firstName}</TableCell>
                                    <TableCell>{user.lastName}</TableCell>
                                    <TableCell>{user.userName}</TableCell>
                                    <TableCell>{user.emailId}</TableCell>
                                    <TableCell><span onClick={() => { user?.allocationId && OpenEditReport(user) }} style={{ textDecoration: 'underline', color: '#ADB792', cursor: user?.allocationId && 'pointer' }}>{user?.venueName}</span><br />{user?.entityName && `(${user?.entityName})`}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            onClick={() => {
                                                const isConfirmed = window.confirm("Are you sure you want to move to Shoper ?")
                                                if (isConfirmed) {
                                                    handleMoveShopper(user.userId)
                                                }
                                            }}
                                            className="table-row-background"
                                        >
                                            Shopper
                                        </Button>
                                    </TableCell>
                                    <TableCell>
                                        <Link
                                            to={`/admin/shopper/update/${user.userId}`}
                                            // onClick={() => {
                                            //     navigate(`/admin/shopper/update/${user.userId}`, {
                                            //         state: { shopperDetails: user },
                                            //     })
                                            // }}
                                            className="table-row-background link-btn"
                                        >
                                            Edit
                                        </Link>
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            className="delete-transparent"
                                            onClick={() => {
                                                const isConfirmed = window.confirm(
                                                    "Are you sure you want to delete the client?"
                                                );
                                                if (isConfirmed) {
                                                    deleteAirTasker(user);
                                                }
                                            }}
                                        >
                                            <DeleteIcon className="delete-icon" />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={datalength}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Box>
    )
}
export default AirTaskerList;
